<template>
  <div class="header-wrapper" id="home">
      <!-- Begin Hero -->
      <section class="hero is-large">
        <!-- Begin Mobile Nav -->
        <nav class="navbar is-transparent is-hidden-desktop">
          <!-- Begin Burger Menu -->
          <div class="navbar-brand">
            <div class="navbar-burger burger" data-target="mobile-nav">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
          <!-- End Burger Menu -->
          <div id="mobile-nav" class="navbar-menu">
            <div class="navbar-end">
              <div class="navbar-item">
                <a class="navbar-item" href="#home">
                  Home
                </a>
              </div>
              <div class="navbar-item">
                <a class="navbar-item" href="#about-me">
                  {{ $t('message.aboutMe.link') }}
                </a>
              </div>
              <div class="navbar-item">
                <a class="navbar-item" href="#services">
                  {{ $t('message.services.link') }}
                </a>
              </div>
              <div class="navbar-item">
                <a class="navbar-item" href="#skills">
                  {{ $t('message.skills.link') }}
                </a>
              </div>
              <div class="navbar-item">
                <a class="navbar-item" href="#experiences">
                  {{ $t('message.experiences.link') }}
                </a>
              </div>
              <div class="navbar-item">
                <a class="navbar-item" href="#resume">
                  {{ $t('message.resume.link') }}
                </a>
              </div>
              <div class="navbar-item">
                <a class="navbar-item" href="#contact">
                  {{ $t('message.contact.link') }}
                </a>
              </div>
              <div>
                <img draggable="false" @dragstart.prevent class="flag flag-selected" data-lang="de" :src="flags.german" @click="changeLanguage($event)">
                <img draggable="false" @dragstart.prevent class="flag" data-lang="en" :src="flags.english" @click="changeLanguage($event)">
              </div>
            </div>
          </div>
        </nav>
        <!-- End Mobile Nav -->
        <!-- Begin Hero Content-->
        <div class="hero-body">
          <div class="container has-text-centered">
            <!-- <h1 class="subtitle">Hey there, I'm</h1> -->
            <h2 class="title">Marco Stumper</h2>
            <h1 class="subtitle profession">Software Engineer</h1>
          </div>
        </div>
        <!-- End Hero Content-->
        <!-- Begin Hero Menu -->
        <div class="hero-foot ">
          <div class="hero-foot-wrapper">
            <div class="columns">
              <div class="column is-12 hero-menu-desktop has-text-centered">
                <ul>
                  <li class="is-active">
                    <a href="#home">Home</a>
                  </li>
                  <li>
                    <a href="#about-me">{{ $t('message.aboutMe.link') }}</a>
                  </li>
                  <li>
                    <a href="#services">{{ $t('message.services.link') }}</a>
                  </li>
                  <li>
                    <a href="#skills">{{ $t('message.skills.link') }}</a>
                  </li>
                  <li>
                    <a href="#experiences">{{ $t('message.experiences.link') }}</a>
                  </li>
                  <li>
                    <a href="#resume">{{ $t('message.resume.link') }}</a>
                  </li>
                  <li>
                    <a href="#contact">{{ $t('message.contact.link') }}</a>
                  </li>
                  <li>
                    <img draggable="false" @dragstart.prevent class="flag flag-selected" style="margin-top: 3px; margin-left: 10px;" :src="flags.german" data-lang="de" @click="changeLanguage($event)">
                  </li>
                  <li>
                    <img draggable="false" @dragstart.prevent class="flag" :src="flags.english" data-lang="en" @click="changeLanguage($event)">
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <!-- End Hero Menu -->
      </section>
      <!-- End Hero -->
    </div>
</template>

<script>
export default {
  name: 'Header',
  components: {
  },
  data() {
    return { flags: {
      'english': 'data:image/svg+xml;base64, PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4NCjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgNjAgMzAiIHdpZHRoPSIxMjAwIiBoZWlnaHQ9IjYwMCI+DQo8Y2xpcFBhdGggaWQ9InMiPg0KCTxwYXRoIGQ9Ik0wLDAgdjMwIGg2MCB2LTMwIHoiLz4NCjwvY2xpcFBhdGg+DQo8Y2xpcFBhdGggaWQ9InQiPg0KCTxwYXRoIGQ9Ik0zMCwxNSBoMzAgdjE1IHogdjE1IGgtMzAgeiBoLTMwIHYtMTUgeiB2LTE1IGgzMCB6Ii8+DQo8L2NsaXBQYXRoPg0KPGcgY2xpcC1wYXRoPSJ1cmwoI3MpIj4NCgk8cGF0aCBkPSJNMCwwIHYzMCBoNjAgdi0zMCB6IiBmaWxsPSIjMDEyMTY5Ii8+DQoJPHBhdGggZD0iTTAsMCBMNjAsMzAgTTYwLDAgTDAsMzAiIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLXdpZHRoPSI2Ii8+DQoJPHBhdGggZD0iTTAsMCBMNjAsMzAgTTYwLDAgTDAsMzAiIGNsaXAtcGF0aD0idXJsKCN0KSIgc3Ryb2tlPSIjQzgxMDJFIiBzdHJva2Utd2lkdGg9IjQiLz4NCgk8cGF0aCBkPSJNMzAsMCB2MzAgTTAsMTUgaDYwIiBzdHJva2U9IiNmZmYiIHN0cm9rZS13aWR0aD0iMTAiLz4NCgk8cGF0aCBkPSJNMzAsMCB2MzAgTTAsMTUgaDYwIiBzdHJva2U9IiNDODEwMkUiIHN0cm9rZS13aWR0aD0iNiIvPg0KPC9nPg0KPC9zdmc+',
      'german': 'data:image/svg+xml;base64, PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIKCSJodHRwOi8vd3d3LnczLm9yZy9HcmFwaGljcy9TVkcvMS4xL0RURC9zdmcxMS5kdGQiPgo8c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjEyMDAiIGhlaWdodD0iNjAwIiB2aWV3Qm94PSIwIDAgNiAzIj4KCTxkZXNjPkZsYWcgb2YgR2VybWFueTwvZGVzYz4KCTxyZWN0IGlkPSJibGFja19zdHJpcGUiIHdpZHRoPSI2IiBoZWlnaHQ9IjMiIHk9IjAiIHg9IjAiIGZpbGw9IiMwMDAiLz4KCTxyZWN0IGlkPSJyZWRfc3RyaXBlIiB3aWR0aD0iNiIgaGVpZ2h0PSIyIiB5PSIxIiB4PSIwIiBmaWxsPSIjRDAwIi8+Cgk8cmVjdCBpZD0iZ29sZF9zdHJpcGUiIHdpZHRoPSI2IiBoZWlnaHQ9IjEiIHk9IjIiIHg9IjAiIGZpbGw9IiNGRkNFMDAiLz4KPC9zdmc+',
    }}
  },
  methods: {
    changeLanguage(event) {
      const selectedLang = event.target.dataset.lang;
      if(this.$i18n.locale == selectedLang) {
        return;
      }
      event.target.closest('section').querySelectorAll('img.flag').forEach((item) => {
        if (item.dataset.lang == selectedLang) {
          item.classList.add('flag-selected');
        } else {
          item.classList.remove('flag-selected');
        }
      });

      this.$i18n.locale = selectedLang;
    }
  },
  mounted() {
    // Get all "navbar-burger" elements
    var $navbarBurgers = Array.prototype.slice.call(
      document.querySelectorAll(".navbar-burger"),
      0
    );
    // Check if there are any navbar burgers
    if ($navbarBurgers.length > 0) {
      // Add a click event on each of them
      $navbarBurgers.forEach(function($el) {
        $el.addEventListener("click", function() {
          // Get the target from the "data-target" attribute
          var target = $el.dataset.target;
          var $target = document.getElementById(target);
          // Toggle the class on both the "navbar-burger" and the "navbar-menu"
          $el.classList.toggle("is-active");
          $target.classList.toggle("is-active");
        });
      });
    }
  }
}
</script>

!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*
.header-wrapper {
  padding-bottom: 30px;
} */

.hero {
  background-attachment: fixed !important;
  background-size: cover !important;
  color: white;
  box-shadow: inset 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
  font-family: 'Poppins', sans-serif;
}

@media all and (max-width: 600px) {
    .hero {
        background: linear-gradient(rgba(31, 44, 108, 0.65), rgba(31, 44, 108, 0.65)), rgba(0, 0, 0, 0.55) url("/img/hero-bg_640.jpg") no-repeat;
    }
}

@media all and (min-width: 600px) and (max-width: 1200px) {
    .hero {
        background: linear-gradient(rgba(31, 44, 108, 0.65), rgba(31, 44, 108, 0.65)), rgba(0, 0, 0, 0.55) url("/img/hero-bg_1280.jpg") no-repeat;
    }
}

@media all and (min-width: 1201px) and (max-width: 1920px) {
    .hero {
        background: linear-gradient(rgba(31, 44, 108, 0.65), rgba(31, 44, 108, 0.65)), rgba(0, 0, 0, 0.55) url("/img/hero-bg_1920.jpg") no-repeat;
    }
}

@media all and (min-width: 1921px) {
    .hero {
        background: linear-gradient(rgba(31, 44, 108, 0.65), rgba(31, 44, 108, 0.65)), rgba(0, 0, 0, 0.55) url("/img/hero-bg.jpg") no-repeat;
    }
}

.hero .title {
  font-family: 'Kaushan Script', sans-serif;
  transform: rotate(-5deg);
  font-size: 5rem;
  color: whitesmoke;
}

.hero .subtitle {
  padding: 5px;
  color: whitesmoke;
}

.hero .profession {
  padding-top: 50px;
  font-size: 1.7rem;
  text-transform: uppercase;
}

.hero .hero-foot {
  background: white;
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.082);
}

@media (max-width: 599px) {
  .hero .hero-foot {
    display: none;
  }
}

.hero .hero-foot .hero-foot-wrapper {
  margin: 7px auto;
}

.hero .hero-foot .hero-foot-wrapper .hero-menu-desktop {
  line-height: 38px;
  font-weight: 600;
  text-transform: lowercase;
  letter-spacing: 1px;
  font-size: 1rem;
}

.hero .hero-foot .hero-foot-wrapper .hero-menu-desktop ul li {
  display: inline-block;
  padding-right: 15px;
  padding-left: 15px;
}

.hero .hero-foot .hero-foot-wrapper .hero-menu-desktop ul li.is-active a {
  border-bottom: 2px solid #1f2c6c;
}

.hero .hero-foot .hero-foot-wrapper .hero-menu-desktop ul li a {
  color: #1f2c6c;
}

.hero .hero-foot .hero-foot-wrapper .hero-menu-desktop ul li a:hover {
  color: #1f2c6c;
  transition: all .2s ease-in-out;
  border-bottom: 2px solid #1f2c6c;
}


.hero .hero-foot .hero-foot-wrapper .flag {
  height: 15px;
}

.hero .hero-foot .hero-foot-wrapper .flag, .hero .navbar-menu .flag {
  user-select: none;
  opacity: 0.2;
  cursor: pointer;
}

.hero .hero-foot .hero-foot-wrapper .flag-selected, .hero .navbar-menu .flag-selected {
  opacity: 1.0;
  cursor: default;
}

.hero .navbar-menu .flag {
  padding-left: 10px; height: 30px;
}

.navbar-burger span {
  background-color: white
}

</style>
